<template>
<v-dialog
    v-model="dialog"
    max-width="920"
>
    <v-card>
        <v-card-title>{{title}}</v-card-title>

        <v-card-text
            v-if="text_markdown"
        >
            <m-showdown
                :value="text"
            />
        </v-card-text>

        <v-card-text
            v-html="text"
            v-else
        >
        </v-card-text>
        
        <v-card-actions>
        <v-btn
            v-if="technical_details != null"
            v-on:click="onClickTechnicalDetails"
            text
        >
            Technical Details
        </v-btn>    

        <v-spacer></v-spacer>

        <v-btn
            color="primary darken-1"
            text
            @click="onOk"
        >
        Ok
        </v-btn>
    </v-card-actions>

    </v-card>

</v-dialog>
</template>

<script>

const Validate = require('@/js/validate.js');
var Preconditions = require('@/js/Preconditions.js'); 

export default {
    data() {
        return {
            dialog: false,
            
            title: '',
            text: '',
            after_alert: null,
            technical_details: null,
            text_markdown: false, 
        }
    },

    created () {
        this.$event_bus.$on('alert', this.showDialog);
    },

    beforeDestroy () {
        this.$event_bus.$off('alert',this.showDialog);
    },

    methods: {

        showDialog(params) 
        {
            this.title = params.title == null ? 'Alert' : params.title;
            this.text = params.text;
            this.after_alert = params.after_alert;
            this.technical_details = params.technical_details;
            this.text_markdown = params.text_markdown == true;

            this.dialog = true;
        },

        onOk() {
            this.dialog = false;

            if ( this.after_alert != null )
            {
                this.after_alert();
            }
        },

        onClickTechnicalDetails()
        {
            this.$rc.technicalDetails({
                'title': 'Technical Details',
                'technical_details': this.technical_details,
            });
        },
    },
}
</script>

<style lang="scss" scoped>
</style>